<div class="gl-page">
  <!-- Back link -->
  <yds-button-back text="Ga terug 'Overzicht boekingsregel'" (back)="goBack()" />

  <!-- Title + page actions -->
  <div class="gl-page__header">
    <h1 class="gl-page__title">Boekingsregel</h1>
    <div class="gl-page__header-actions">
      @if (!isAddMode()) {
        <yds-button (click)="goToBookingGroup()">Boekingsgroep</yds-button>
        <yds-button (click)="goToBookingDefinition()">Boekingsdefinitie</yds-button>
        <yds-button variant="destructive" (click)="onDelete()">Verwijderen</yds-button>
      }
    </div>
  </div>

  @if (isLoading()) {
    <div class="gl-detail-loading">
      <yds-spinner [label]="'Boekingsregel laden...'" />
    </div>
  } @else {
  <!-- Details card -->
  <yds-card-editable
    title="Details"
    [(editing)]="detailsEditing"
    [nextDisabled]="isSaving() || form.invalid"
    [nextLabel]="isAddMode() ? 'Volgende' : 'Opslaan'"
    (cancel)="onDetailsCancel()"
    (next)="onDetailsNext()"
  >
    @if (notFound()) {
      <p class="bre-empty">Er zijn geen details voor boekingsregel gevonden.</p>
    } @else if (detailsEditing()) {
      <form class="gl-form" [formGroup]="form">
        <p class="gl-form__required-hint">
          Velden gemarkeerd met een sterretje
          (<span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span>) zijn verplicht.
        </p>

        <!-- Boekingsdefinitie -->
        <div class="gl-field">
          <label class="gl-field__label">
           <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Boekingsdefinitie 
          </label>
          <div class="gl-field__control">
            @if (isAddMode()) {
              <yds-combobox
                formControlName="bookingDefinitionId"
                [items]="bookingDefinitionOptions()"
                [required]="true"
                [hasError]="isInvalid(form.get('bookingDefinitionId'))"
                [errorMsg]="'Boekingsdefinitie is verplicht.'"
                [placeholder]="'Selecteer een boekingsdefinitie'"
              />
            } @else {
              <p class="gl-field__readonly-text">{{ bookingDefinitionDisplay() }}</p>
            }
          </div>
        </div>

        <!-- Percentage -->
        <div class="gl-field">
          <label class="gl-field__label">
           <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Percentage 
          </label>
          <div class="gl-field__control">
            <yds-text-field
              formControlName="bookingPercentage"
              [required]="true"
              [hasError]="isInvalid(form.get('bookingPercentage'))"
              [errorMsg]="'Percentage is verplicht.'"
              [placeholder]="'100'"
            />
          </div>
        </div>

        <!-- Grootboekrekening -->
        <div class="gl-field">
          <label class="gl-field__label">
           <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Grootboekrekening 
          </label>
          <div class="gl-field__control">
            <yds-combobox
              formControlName="generalLedgerAccountId"
              [items]="glAccountOptions()"
              [required]="true"
              [hasError]="isInvalid(form.get('generalLedgerAccountId'))"
              [errorMsg]="'Grootboekrekening is verplicht.'"
              [placeholder]="'Selecteer een grootboekrekening'"
            />
          </div>
        </div>

        <!-- Soort boeking -->
        <div class="gl-field">
          <label class="gl-field__label">
           <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Soort boeking 
          </label>
          <div class="gl-field__control">
            <yds-dropdown
              formControlName="kindOfBooking"
              [items]="kindOfBookingOptions"
              [allowClear]="false"
              [placeholder]="'Selecteer soort boeking'"
            />
          </div>
        </div>

        <!-- Aantallen in boeking -->
        <div class="gl-field">
          <label class="gl-field__label">Aantallen in boeking</label>
          <div class="gl-field__control">
            <yds-dropdown
              formControlName="includeNumberInBooking"
              [items]="includeNumberInBookingOptions"
              [allowClear]="false"
              [placeholder]="'Selecteer aantallen in boeking'"
            />
          </div>
        </div>

        <!-- Tekenomslag toepassen -->
        <div class="gl-field gl-field--inline">
          <label class="gl-field__label">Tekenomslag toepassen</label>
          <div class="gl-field__control">
            <yds-switch formControlName="applySignChange" />
          </div>
        </div>

        <!-- Boeken per persoon -->
        <div class="gl-field gl-field--inline">
          <label class="gl-field__label">Boeken per persoon</label>
          <div class="gl-field__control">
            <yds-switch formControlName="bookByEmployment" />
          </div>
        </div>
      </form>
    } @else {
      <div class="gl-detail">
        <div class="gl-detail__row">
          <span class="gl-detail__label">Boekingsdefinitie</span>
          <span class="gl-detail__value">{{ bookingDefinitionDisplay() }}</span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Grootboekrekening</span>
          <span class="gl-detail__value">{{ generalLedgerAccountDisplay() }}</span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Percentage</span>
          <span class="gl-detail__value">{{ percentageDisplay() }}</span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Soort boeking</span>
          <span class="gl-detail__value">{{ kindOfBookingDisplay() }}</span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Aantallen in boeking</span>
          <span class="gl-detail__value">{{ includeNumberDisplay() }}</span>
        </div>
        <div class="gl-detail__row gl-detail__row--inline">
          <span class="gl-detail__label">Tekenomslag toepassen</span>
          <span class="gl-detail__value gl-detail__value--setting">
            @if (applySignChangeDisplay()) {
              <span class="vismaicon vismaicon-dynamic vismaicon-sm vismaicon-checkmark" aria-hidden="true"></span>
              <span>Ja</span>
            } @else {
              <span>Nee</span>
            }
          </span>
        </div>
        <div class="gl-detail__row gl-detail__row--inline">
          <span class="gl-detail__label">Boeken per persoon</span>
          <span class="gl-detail__value gl-detail__value--setting">
            @if (bookByEmploymentDisplay()) {
              <span class="vismaicon vismaicon-dynamic vismaicon-sm vismaicon-checkmark" aria-hidden="true"></span>
              <span>Ja</span>
            } @else {
              <span>Nee</span>
            }
          </span>
        </div>
      </div>
    }
  </yds-card-editable>

  <!-- Criteria card (only once the rule exists) -->
  @if (!isAddMode()) {
    <yds-card-editable
      class="bre-card"
      title="Criteria"
      [(editing)]="criteriaEditing"
      [nextDisabled]="isSavingCriteria()"
      nextLabel="Opslaan"
      (cancel)="onCriteriaCancel()"
      (next)="onCriteriaSave()"
    >
      @if (criteriaEditing()) {
        <div class="gl-grid-wrapper">
          <table class="gl-grid">
            <thead>
              <tr>
                <th class="bre-grid__col--criterium">Criterium</th>
                <th class="bre-grid__col--element">Element</th>
                <th>Vervangende waarde</th>
                <th class="gl-grid__col--action"></th>
              </tr>
            </thead>
            <tbody>
              @if (criteriaRows().length === 0) {
                <tr class="gl-grid__empty">
                  <td colspan="4">Nog geen criteria toegevoegd.</td>
                </tr>
              } @else {
                @for (row of criteriaRows(); track $index; let i = $index) {
                  <tr>
                    <td class="bre-grid__col--criterium">
                      <yds-combobox
                        [items]="availableCriterionOptions(i)"
                        [value]="criterionValue(row)"
                        (valueChange)="onCriterionNumberChange(i, $event)"
                        [allowClear]="true"
                        [placeholder]="'Selecteer een criterium'"
                      />
                    </td>
                    <td class="bre-grid__col--element">
                      <yds-combobox
                        [items]="elementOptions()"
                        [value]="row.elementId"
                        (valueChange)="onCriterionElementChange(i, $event)"
                        [allowClear]="true"
                        [placeholder]="'Selecteer een element'"
                      />
                    </td>
                    <td>
                      <yds-text-field
                        [ngModel]="row.value ?? ''"
                        [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="onCriterionValueChange(i, $event)"
                        [placeholder]="'Vervangende waarde'"
                      />
                    </td>
                    <td class="gl-grid__col--action">
                      <button
                        type="button"
                        class="gl-grid__remove"
                        aria-label="Verwijder criterium"
                        (click)="removeCriterionRow(i)"
                      >
                        <span class="vismaicon vismaicon-dynamic vismaicon-sm vismaicon-delete" aria-hidden="true"></span>
                      </button>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>

        @if (canAddCriterionRow()) {
          <button type="button" class="gl-grid__add-link" (click)="addCriterionRow()">
            + Criteria toevoegen
          </button>
        }
      } @else {
        @if (criteriaRows().length === 0) {
          <p class="bre-empty">Nog geen criteria toegevoegd.</p>
        } @else {
          <div class="gl-grid-wrapper">
            <table class="gl-grid">
              <thead>
                <tr>
                  <th class="bre-grid__col--criterium">Criterium</th>
                  <th class="bre-grid__col--element">Element</th>
                  <th>Vervangende waarde</th>
                </tr>
              </thead>
              <tbody>
                @for (row of criteriaRows(); track $index) {
                  <tr>
                    <td class="bre-grid__col--criterium">{{ criterionLabel(row) }}</td>
                    <td class="bre-grid__col--element">{{ elementLabel(row.elementId) }}</td>
                    <td>{{ row.value }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      }
    </yds-card-editable>
  }
  }
</div>
